<style scoped lang="scss">
@import "index.scss";
.nav .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background: inherit;
}
.nav .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
  background: inherit;
}
.nav .ivu-menu-vertical .ivu-menu-item:hover, .ivu-menu-vertical .ivu-menu-submenu-title:hover {
  background: #f3f3f3;
}

.warning-icon {
  color: #f90;
  font-size: 16px;
  margin-right: 4px;
}
</style>
<template>
    <div :class="['nav','scrollbar',$demo?'demo':'']">

      <ul
        v-for="(itemList, oIndex) in navList" :key="oIndex"
        v-if="routerFirst === itemList.routerFirst"
        :router="routerFirst"
        class="ivu-menu ivu-menu-light ivu-menu-vertical"
      >
        <li v-for="(subItem, aIndex) in itemList.submenu" :key="aIndex"
          v-if="subItem.shown"
          :class="['ivu-menu-submenu',
            {'ivu-menu-opened': subItem.opened,
            'ivu-menu-item-active': subItem.actived}]">
          <div class="ivu-menu-submenu-title" @click="closeSubmenu(oIndex, aIndex)">
            <i :class="['title-icon', 'iconfont', subItem.menuIcon,
              {'lager': subItem.lagerIcon}]"></i>
            <span class="title-con">{{ $t(subItem.menuTitle) }}</span>
            <Icon class="ivu-menu-submenu-title-icon" type="ios-arrow-down"></Icon>
          </div>
          <ul class="ivu-menu" v-show="subItem.opened">
            <li
              v-if="judgeAppletPage(item)"
              v-for="(item, index) in subItem.menuItems" :key="index">
              <p v-if="item.shown || allListShow" :class="['ivu-menu-item',
                {'ivu-menu-item-selected': item.actived,
                'ivu-menu-item-active': item.actived}]"
              @click="jurgeRouter(item, oIndex, aIndex, index)"
              :style="{'padding-left': alertMap[item.key] ? '20px' : '44px'}">
                <span v-if="alertMap[item.key]" class="warning-icon"><i class="ivu-icon ivu-icon-md-alert"></i></span>
                {{ $t(item.title) }}
              </p>
            </li>
          </ul>
        </li>
      </ul>

      <div class="nav-bg" v-show="navShow" @click="handleCloseNav" ></div>
      <!-- 通用询问窗口，当前页处于设置页面，跳转其他页面时的提示 -->
      <Modal
        v-model="discardChangeShow"
        :mask-closable="false"
        @on-ok="discardChange"
      >
        {{ $t('common.noSave') }} <br/>
        {{ $t('common.isLeave') }}
      </Modal>
    </div>
</template>
<script>
import bus from '../../libs/bus';
import navMenu from '../../libs/navigation-menu';
import showModal from '../../config/tip-others-config';
import BaseLib from '../../base/BaseLib';
import AnalyticsPublic from '../../base/AnalyticsPublic';
import StateHandler from '../../base/StateHandler';
import util from '../../libs/util';

export default {
  data() {
    const path = this.$route.path.split(`/${this.$route.params.productid}`)[0];
    const subs = path.split('/');
    const prefix = `${subs[0]}/${subs[1]}/${subs[2]}/${subs[3]}`;
    return {
      activeKey: prefix,
      routerFirst: subs[1],
      navShow: false,
      navList: navMenu,
      allListShow: false,
      allActive: false,
      authorizedpage: [],
      entry: {},
      discardChangeShow: false, // 控制modal框显示隐藏
      toPath: {}, // 点击nav存储的相关参数

      alertMap: {
        '/push/main/index': 1,
        '/push/options/index': 1,
        '/analytics/overview/uninstallOpen': 1,
      },
    };
  },
  computed: {
    curProdId() {
      return this.$store.state.transFilterObj.productid;
    },
    curPlat() {
      return this.$store.state.transFilterObj.platform;
    },
    path() {
      const tmp = this.$route.path.split(`/${this.$route.params.productid}`)[0];
      const subs = tmp.split('/');
      return `${subs[0]}/${subs[1]}/${subs[2]}/${subs[3]}`;
    },
  },
  watch: {
    path() {
      this.getPathKey();
      this.hiddenEntry('actived');
    },
  },
  mounted() {
    // pad下，监听展开和关闭导航项
    bus.$on('on-nav-toggle', () => {
      this.navShow = true;
    });
    // 监听应用变更获取menu入口权限
    bus.$on('on-app-change-nav', () => {
      this.hiddenEntry('appChange');
    });
    // 监听platform改变
    bus.$on('on-platform-change-nav', () => {
      this.hiddenEntry('platformChange');
    });

    this.$nextTick(() => {
      this.getPathKey();
      this.hiddenEntry();
    });
  },
  methods: {
    // 询问窗口 确定按钮
    discardChange() {
      this.changeRouter(this.toPath.key, this.toPath.oIndex, this.toPath.aIndex, this.toPath.index);
    },
    closeSubmenu(oIndex, aIndex) {
      this.navList[oIndex].submenu[aIndex].opened = !this.navList[oIndex].submenu[aIndex].opened;
    },
    /**
     * 保存用户菜单的行为
     */
    saveUserBehavior(data, oIndex, aIndex){
        try {
            let path = `${this.$t(this.navList[oIndex].submenu[aIndex].menuTitle)}/${this.$t(data.title)}`;
            let email = StateHandler.store.state.developerObj.email;
            util.ajax.post('/app/rest/smartData/fun', { email: email, funName: path, pid: AnalyticsPublic.productid });
        } catch (error) {
            console.log('菜单行为上传失败');
        }
    },
    jurgeRouter(data, oIndex, aIndex, index) {
      let key = data.key;
      // 应用分析 保持数据概览展开，其余为手风琴模式
      if (oIndex === 0) {
        this.navList[oIndex].submenu.forEach((item) => {
          // eslint-disable-next-line
          item.opened = false;
        });
        this.navList[oIndex].submenu[0].opened = true;
        this.navList[oIndex].submenu[aIndex].opened = true;
      }
      this.toPath.key = key;
      this.toPath.oIndex = oIndex;
      this.toPath.aIndex = aIndex;
      this.toPath.index = index;
      // 判断当前路由是否为设置页面，是则发送事件弹出窗口提示
      const showModalList = showModal.isShowModal;
      const currentPath = this.$route.path;
      const filterPath = showModalList.filter(x => currentPath.indexOf(x) > -1);
      if (filterPath.length > 0) {
        this.discardChangeShow = true;
        return;
      }
      BaseLib.checkEmit(this.$root, 'check-change-menu', {
        title: '切换菜单提示',
        callback: () => {
          this.saveUserBehavior(data, oIndex, aIndex);
          this.changeRouter(key, oIndex, aIndex, index);
        },
      });
    },
    changeRouter(key, oIndex, aIndex, index) {
      if (key.indexOf('manage/overview/channel') !== -1 || key.indexOf('smart-scan') !== -1) {
        // 平台单选
        bus.$emit('on-platform-single');
      }
      // TODO 单选IOS平台
      if (key.indexOf('analytics/overview/uninstallOpen') !== -1) {
        if (this.curPlat.includes(2)) {
          bus.$emit('on-platform-single', 2);
        }
      }
      if (this.routerFirst === 'account') {
        this.$router.push(key);
      } else {
        this.$router.push(`${key}/${(this.curProdId || this.$route.params.productid)}`);
      }

      this.navList[oIndex].submenu[aIndex].menuItems[index].actived = true;
      this.navList[oIndex].submenu[aIndex].actived = true;
    },
    handleSelect(key) {
      if (key.indexOf('manage/overview/channel') !== -1) {
        // 平台单选
        bus.$emit('on-platform-single');
      }
      // 单选IOS平台
      // if (key.indexOf('analytics/overview/uninstallAnalytics') !== -1) {
      //   bus.$emit('on-platform-single', 2);
      // }
      if (this.routerFirst === 'account') {
        this.$router.push(key);
      } else {
        this.$router.push(`${key}/${(this.curProdId || this.$route.params.productid)}`);
      }
    },
    // 获取当前页面路径和路由模块
    getPathKey() {
      const path = this.$route.path.split(`/${this.$route.params.productid}`)[0];
      const subs = path.split('/');
      let subs3 = subs[3];
      if (subs[3] === 'setFunnel' || subs[3] === 'funnelChart') {
        subs3 = 'funnel';
      } else if (subs[2] === 'err' && subs[3] === 'detail') {
        subs3 = 'list';
      } else if (subs[2] === 'exportLog' && subs[3] === 'list') {
        subs3 = 'overview';
      } else if (subs[3] === 'uninstallAnalytics') {
        subs3 = 'uninstallOpen';
      }
      const prefix = `${subs[0]}/${subs[1]}/${subs[2]}/${subs3}`;
      this.activeKey = prefix;
      this.routerFirst = subs[1];
    },
    handleCloseNav() {
      this.navShow = false;
    },
    getPageList() {
      const productInfo = this.$store.state.productObj;
      let authorizedpage = [];

      this.allListShow = false;
      this.authorizedpage = [];
      this.allActive = false;

      if (!productInfo.authorized) {
        this.allListShow = true;
        // alert(this.allListShow);
      } else {
        authorizedpage = productInfo.authorizedpage ?
          productInfo.authorizedpage.split(',') : [];
          // 默认开启的授权页面
        authorizedpage.push('authorizeAccount', 'essentialInformation');
      }

      this.authorizedpage = authorizedpage;
    },
    /*
     *隐藏入口,控制导航选中状态
     *@type ['actived', 'appChange', 'platformChange']
     *actived:修改导航选中状态，appChange:切换应用, platformChange:切换平台
    */
    hiddenEntry(type) {
      // 只有在切换应用时获取授权权限
      if (type !== 'actived') {
        this.getPageList();
      }
      let hasAuthority = false; // 当前页面是否被授权
      let appFirstPath = '';
      // 是否为小程序相关页面
      let appletRelated = false;

      for (let i = 0, llen = this.navList.length; i < llen; i += 1) {
        const menuList = this.navList[i];
        const bigMenu = menuList.routerFirst;

        if (type !== 'actived') {
          bus.headerNavShown[bigMenu] = false;
        }

        if(bigMenu === 'dashboard' || bigMenu === 'gameReport'){
          let tmpAuth = false;
          /* 判断当前页面是否在权限范围内 */
          if (this.allListShow) { // 创建者
            tmpAuth = true;
          } else { // 其他用户
            const indexInArr = this.authorizedpage.indexOf(bigMenu);
            if (indexInArr > -1) {
              tmpAuth = true;
            }
          }
          hasAuthority = tmpAuth;
          bus.headerNavShown[bigMenu] = tmpAuth;
        }

        for (let j = 0, ll = menuList.submenu.length; j < ll; j += 1) {
          const oMenu = menuList.submenu[j];
          const menuItem = oMenu.menuItems;
          oMenu.actived = false;
          oMenu.shown = type === 'actived' ? oMenu.shown : false;

          for (let m = 0, l = menuItem.length; m < l; m += 1) {
            const pages = menuItem[m].authorizeName;
            /* 判断当前路径对应的menu */
            if (this.activeKey === menuItem[m].key) {
              appletRelated = menuItem[m].appletRelated;
              /* 默认展开数据概览和当前项菜单，其余缩起*/
              if (i === 0) {
                this.navList[i].submenu.forEach((item) => {
                  // eslint-disable-next-line
                  item.opened = false;
                });
                this.navList[i].submenu[0].opened = true;
                this.navList[i].submenu[j].opened = true;
              }
              /* 判断当前页面是否在权限范围内 */
              if (this.allListShow) { // 创建者
                hasAuthority = true;
              } else { // 其他用户
                for (let n = 0, len = pages.length; n < len; n += 1) {
                  const indexInArr = this.authorizedpage.indexOf(pages[n]);
                  if (indexInArr > -1) {
                    hasAuthority = true;
                    break;
                  }
                }
              }
              /* 非授权路径且非改变app状态调用，直接跳至列表页 */
              if (!hasAuthority && type !== 'appChange') {
                this.$Message.warning({
                  content: '未授权此功能，已跳转到产品中心',
                });
                this.$router.push('/productCenter');
                // window.location(`${util.baseURL}/spa/analytics/#!/productCenter`);
                break;
              }
              menuItem[m].actived = true;
              oMenu.actived = true;
            } else {
              menuItem[m].actived = false;
            }

            /* 若只为改变actived状态，则不用修改显示 */
            if (type !== 'actived') {
              /* 如果是圆形图标，设置图标放大 */
              if (oMenu.menuIcon === 'icon-explore' || oMenu.menuIcon === 'icon-eauth') {
                oMenu.lagerIcon = true;
              }

              /* 若为创建者，显示全部子项 */
              if (this.allListShow) {
                menuItem[m].shown = true;
                oMenu.shown = true;
                bus.headerNavShown[bigMenu] = true;
                appFirstPath = `/analytics/overview/app/${this.curProdId}`;
              } else {
                /* 账户授权页始终显示 */
                if (bigMenu === 'account') {
                  menuItem[m].shown = true;
                  oMenu.shown = true;
                  break;
                }

                /* 判断菜单子项是否显示 */
                for (let n = 0, len = pages.length; n < len; n += 1) {
                  const indexInArr = this.authorizedpage.indexOf(pages[n]);
                  if (indexInArr > -1) {
                    /* 记录当前应用被授权的第一个路径 */
                    if (!appFirstPath) {
                      appFirstPath = `${menuItem[m].key}/${this.curProdId}`;
                    }
                    menuItem[m].shown = true;
                    oMenu.shown = true;
                    bus.headerNavShown[bigMenu] = true;
                    break;
                  } else {
                    menuItem[m].shown = false;
                  }
                }
              }
            }
          }
        }
      }
      /* 切换app状态且无当前路径时，跳转至该app被授权的第一个路径 */
      if (type === 'appChange' && !hasAuthority) {
        this.$router.push(appFirstPath);
      }

      // 切换应用时，若账号有当前路径权限且为小程序相关页面且平台不包含32时执行以下逻辑,实现跳转
      if (type === 'appChange' && hasAuthority && !this.curPlat.includes(32) && appletRelated) {
        this.$router.push(appFirstPath);
      }

      if (type !== 'actived') {
        bus.$emit('header-nav-shown');
      }

      // 小程序相关页面 切换平台时，若平台不包含32 跳转至“应用概览”
      if (type === 'platformChange' && !this.curPlat.includes(32) && appletRelated) {
        this.$router.push(appFirstPath);
      }
    },
    /*
     *判断是否显示小程序相关的页面
     * @param {[Object]} currentPage   [当前page的配置参数]
    */
    judgeAppletPage(currentPage) {
      let isShowPage = true;
      if (currentPage.appletRelated && !this.curPlat.includes(32)) {
        isShowPage = false;
      }
      return isShowPage;
    },
  },
};
</script>
